import React from "react";
import { Link } from "react-router-dom";
import BlogCard from "../../components/common/BlogCard/BlogCard";
import InteractiveText from "../../components/common/Typography/InteractiveText";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_HOME_BLOG_GRID_CLASS,
  PUBLIC_CARD_GRID_GAP_CLASS,
  PUBLIC_IMAGE_TO_HEADING_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_BODY_TO_LINK_CLASS,
} from "../Public/shared/publicLayoutSpec";

const Relatedblogs = () => {
  const Blogs = [
    {
      blogName:
        "Blog Name Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
    {
      blogName:
        "Choose from the best Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
    {
      blogName:
        "Blog Name Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
  ];
  const BlogsMobile = [
    {
      blogName:
        "Blog Name Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
    {
      blogName:
        "Choose from the best Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
    {
      blogName:
        "Blog Name Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
    {
      blogName:
        "Blog Name Go through the list of service providers and select the best service on the basis of reviews.",
      text: "Go through the list of service providers and select the best service on the basis of reviews. Connect with the service provider via contact number or email address to get a final quote and avail their best services.",
    },
  ];
  return (
    <>
      <div className={`flex justify-center ${PUBLIC_SECTION_GAP_CLASS} w-full`}>
        <div>
          <div className="flex items-center justify-end">
            <Link to={"/blogs"}>
              <InteractiveText
                variant={"ActionLink"}
                className={"text-offblack hover:text-primaryblue font-semibold"}
              >
                All categories
              </InteractiveText>
            </Link>
          </div>
          <div
            className={`lg:hidden ${PUBLIC_HOME_BLOG_GRID_CLASS} ${PUBLIC_CARD_GRID_GAP_CLASS} ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
          >
            {BlogsMobile.map((e, index) => {
              return (
                <BlogCard
                  key={index}
                  blogName={e.blogName.split(/\s+/).slice(0, 8).join(" ")}
                  text={e.text}
                  imageToTitleClassName={PUBLIC_IMAGE_TO_HEADING_CLASS}
                  titleToBodyClassName={PUBLIC_HEADING_TO_BODY_CLASS}
                  bodyToLinkClassName={PUBLIC_BODY_TO_LINK_CLASS}
                />
              );
            })}
          </div>
          {/* For Lg Screens */}
          <div
            className={`hidden lg:grid ${PUBLIC_HOME_BLOG_GRID_CLASS} mx-[5%] lg:mx-auto lg:w-[900px] xl:w-fit ${PUBLIC_CARD_GRID_GAP_CLASS} ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
          >
            {Blogs.map((e, index) => {
              return (
                <BlogCard
                  key={index}
                  blogName={e.blogName.split(/\s+/).slice(0, 8).join(" ")}
                  text={e.text}
                  imageToTitleClassName={PUBLIC_IMAGE_TO_HEADING_CLASS}
                  titleToBodyClassName={PUBLIC_HEADING_TO_BODY_CLASS}
                  bodyToLinkClassName={PUBLIC_BODY_TO_LINK_CLASS}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Relatedblogs;
